import React from 'react';

// Components
import { ConversationNotifications } from '../modules/conversation-notifications/conversation-notifications';

// Styles
import './chat-status-in-call.scss';

export const ChatStatusInCall = () => {

  const workerId = localStorage.getItem('worker_id');
  const returnPathname = localStorage.getItem('return_pathname') ?? `/expert/${workerId}`;

  return (<ConversationNotifications
    title={'Consultant Unavailable'}
    text={'Unfortunately, the Consultant has already started another connection. You may try to contact them later. The payment for the Text Chat will be refunded to you.'}
    navigateAction={returnPathname}  />);
}
